export { default } from 'crehana-ui/LazyImage/LazyImageResponsive';
